import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'saeculum-formly',
  templateUrl: './saeculum-angular-formly-layout.html',
  styleUrls: ['./saeculum-angular-formly-layout.scss'],
})
export class SaeculumAngularFormlyLayoutComponent implements OnInit, OnChanges {

  @Input() form: FormGroup;
  @Input() options: any;
  @Input() values: any;
  @Input() fieldList: any;
  @Input() isLoading = true;
  @Output() submitForm = new EventEmitter();
  @Output() valueChange = new EventEmitter<any>();


  constructor() { }

  ngOnInit() {
    // const formGroup = {};
    // for (const field of this.fieldList) {
    //   for (const subfield of field.fields) {
    //     if (subfield.validators && subfield.validators.required) {
    //       formGroup[subfield.key] = new FormControl(this.values[subfield.key] || null, Validators.required);
    //     } else if (subfield.type !== 'formArray') {
    //       formGroup[subfield.key] = new FormControl(this.values[subfield.key] || null);
    //     }
    //   }
    // }
    if (!this.form) {
      this.form = new FormGroup({});
    }
    this.valueChange.emit({ key: 'FormReady', value: this.form });
  }

  onValueChange(event) {
    if (event.key === 'FormReady') {
      this.form = event.value;
    }
    this.valueChange.emit(event);
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log("FORM-COMPO : ", changes);
  }
}
